
import * as actionTypes from './actionType';

export const selectTool = (toolID) => { return {type: actionTypes.SET_TOOL, 'currentToolID': toolID} }
